module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAMAAABl5a5YAAAAaVBMVEUAAACZmZmZmZmZmZmYmJiAgICYmJiZmZmZmZmampqUlJSRkZGZmZmZmZmampqYmJiZmZmYmJiXl5eYmJiXl5eZmZmZmZmampqZmZmampqZmZmZmZmZmZmYmJiZmZmYmJiampqZmZmZmZlfs2hdAAAAInRSTlMA7l/5yQbz49qrGw7RkINlvXhYSkMzw7GjmVtPLyEUiz0oTO2VrgAAAJdJREFUGNNNjlcSwyAMRKXQsQGXuJckuv8hEwJ4/H6edjWjEUQqJ4lUgEJVY/vsF3KlcPiJWumZC2yT+Zxsy+bFkwVb02AaSDSjiLKszcXAzAmway0g0yPjmvgBBduNqMxmczwmyjRDzG9Zd+f/4Y3L/iecrlvCSAseK7gQaoHawQ2vQIZ70RGo2odHJniOsM+aUYZpM3wBwlwIx09G9rcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/user.png
// module id = m27p
// module chunks = 6